import { render, staticRenderFns } from "./TippyTours.vue?vue&type=template&id=951e0ffa&"
import script from "./TippyTours.vue?vue&type=script&lang=ts&"
export * from "./TippyTours.vue?vue&type=script&lang=ts&"
import style0 from "./TippyTours.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports